import { render, staticRenderFns } from "./ManualCreateServer.vue?vue&type=template&id=c85a52c8&scoped=true"
import script from "./ManualCreateServer.vue?vue&type=script&lang=js"
export * from "./ManualCreateServer.vue?vue&type=script&lang=js"
import style0 from "./ManualCreateServer.vue?vue&type=style&index=0&id=c85a52c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85a52c8",
  null
  
)

export default component.exports